import { render, staticRenderFns } from "./LayoutTabs.vue?vue&type=template&id=52499a0c&scoped=true"
import script from "./LayoutTabs.vue?vue&type=script&lang=js"
export * from "./LayoutTabs.vue?vue&type=script&lang=js"
import style0 from "./LayoutTabs.vue?vue&type=style&index=0&id=52499a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52499a0c",
  null
  
)

export default component.exports